import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Svg = styled.svg.withConfig({
	displayName: "Aggregate__Svg",
	componentId: "sc-1jenxid-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Aggregate = function Aggregate(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1569.3496 1375.1826", scale: scale },
		React.createElement("circle", { fill: fill, cx: "1337.3159", cy: "688.0463", r: "232.0337" }),
		React.createElement("polygon", {
			fill: fill,
			points: "541.476 1210.443 454.401 1114.269 833.139 695.953 454.401 277.636 541.476 181.462 1007.287 695.953 541.476 1210.443"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M303.0469,1071.7959c-95.666,0-173.4956-77.83-173.4956-173.4961s77.83-173.4951,173.4956-173.4951S476.5425,802.6343,476.5425,898.3,398.7129,1071.7959,303.0469,1071.7959Zm0-286.9912A113.4956,113.4956,0,1,0,416.5425,898.3,113.6239,113.6239,0,0,0,303.0469,784.8047Z",
			transform: "translate(-129.5513 -210.709)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M303.0469,557.7c-95.666,0-173.4956-77.83-173.4956-173.4956s77.83-173.4956,173.4956-173.4956,173.4956,77.83,173.4956,173.4956S398.7129,557.7,303.0469,557.7Zm0-286.9912A113.4956,113.4956,0,1,0,416.5425,384.2046,113.6243,113.6243,0,0,0,303.0469,270.709Z",
			transform: "translate(-129.5513 -210.709)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M303.0469,1585.8916c-95.666,0-173.4956-77.83-173.4956-173.4961S207.3809,1238.9,303.0469,1238.9s173.4956,77.8291,173.4956,173.4951S398.7129,1585.8916,303.0469,1585.8916Zm0-286.9912a113.4956,113.4956,0,1,0,113.4956,113.4951A113.6242,113.6242,0,0,0,303.0469,1298.9Z",
			transform: "translate(-129.5513 -210.709)"
		})
	);
};

Aggregate.defaultProps = {
	fill: "#000000",
	scale: 1
};

Aggregate.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1 = styled.svg.withConfig({
	displayName: "AreaChart__Svg",
	componentId: "sc-1a782wa-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var AreaChart = function AreaChart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1776.9,1447 1776.9,1557.1 15.7,1557.1 15.7,236.2 125.8,236.2 125.8,1447 "
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "264.8,1317.9 1660.4,1314.7 1446.7,566.4 1116.5,841.6 621.1,346.3 264.8,808.5 "
		})
	);
};

AreaChart.defaultProps = {
	fill: "#000000",
	scale: 1
};

AreaChart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$2 = styled.svg.withConfig({
	displayName: "Arrow__Svg",
	componentId: "sc-1ik602y-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Arrow = function Arrow(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$2,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 475.93 270.04", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M466.53,207.5H79.4l69.1-78a11.57,11.57,0,0,0-1.07-16.18L130.19,98.21A11.57,11.57,0,0,0,114,99.28L4.86,222.45a12.82,12.82,0,0,0,0,16L114,361.59a11.57,11.57,0,0,0,16.18,1.07l17.25-15.12a11.57,11.57,0,0,0,1.07-16.18l-69.1-78H466.53A11.57,11.57,0,0,0,478,241.9V219A11.57,11.57,0,0,0,466.53,207.5Z",
			transform: "translate(-2.07 -95.41)"
		})
	);
};

Arrow.defaultProps = {
	fill: "#000000",
	scale: 1
};

Arrow.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$3 = styled.svg.withConfig({
	displayName: "BarChart__Svg",
	componentId: "sc-czls5z-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var BarChart = function BarChart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$3,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M562.8,908.1V1274c0,21.6-17.5,39.1-39.1,39.1H379.9c-21.6,0-39.1-17.5-39.1-39.1V908.1c0-21.6,17.5-39.1,39.1-39.1h143.9C545.3,869,562.8,886.5,562.8,908.1z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1066.9,455.5v826.9c0,16.9-13.7,30.6-30.6,30.6H875.5c-16.9,0-30.6-13.7-30.6-30.6V455.5c0-16.9,13.7-30.6,30.6-30.6h160.8C1053.2,424.9,1066.9,438.6,1066.9,455.5z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1784,1477v59.1c0,14.3-11.6,25.9-25.9,25.9H90.6c-45.7,0-82.8-37.1-82.8-82.8V255.8c0-14.3,11.6-25.9,25.9-25.9h59.1c14.3,0,25.9,11.6,25.9,25.9v1169.3c0,14.3,11.6,25.9,25.9,25.9h1613.4C1772.4,1451.1,1784,1462.7,1784,1477z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1571,680.4v599.2c0,18.5-15,33.4-33.4,33.4h-155.2c-18.5,0-33.4-15-33.4-33.4V680.4c0-18.5,15-33.4,33.4-33.4h155.2C1556,647,1571,661.9,1571,680.4z"
		})
	);
};

BarChart.defaultProps = {
	fill: "#000000",
	scale: 1
};

BarChart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$4 = styled.svg.withConfig({
	displayName: "Broadcast__Svg",
	componentId: "sc-1vs6zpr-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Broadcast = function Broadcast(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$4,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 412.5901 316.8585", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M124.0093,253.226s3.972,8.774,21.972-.226,15.3292-16.8295,15.3292-16.8295a81.7041,81.7041,0,0,1,0-68.1743S163.9813,160,142.9813,151c-17.2692-7.4011-18.9719-.0594-18.9719-.0594a122.8739,122.8739,0,0,0,0,102.2854Z",
			transform: "translate(-29.8602 -113.2903)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M70.86,202.0835a164.0269,164.0269,0,0,1,14.9561-68.6063S88.9813,125,69.9813,117s-21.4487-.57-21.4487-.57a205.7908,205.7908,0,0,0,0,171.3074S50.9813,297,70.9813,288s14.835-17.31,14.835-17.31A164.0262,164.0262,0,0,1,70.86,202.0835Z",
			transform: "translate(-29.8602 -113.2903)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M348.3012,253.226S344.3293,262,326.3293,253,311,236.1705,311,236.1705a81.7041,81.7041,0,0,0,0-68.1743S308.3293,160,329.3293,151c17.2691-7.4011,18.9719-.0594,18.9719-.0594a122.8734,122.8734,0,0,1,0,102.2854Z",
			transform: "translate(-29.8602 -113.2903)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M401.45,202.0835a164.0269,164.0269,0,0,0-14.9561-68.6063S383.3293,125,402.3293,117s21.4486-.57,21.4486-.57a205.79,205.79,0,0,1,0,171.3074S421.3293,297,401.3293,288s-14.835-17.31-14.835-17.31A164.0262,164.0262,0,0,0,401.45,202.0835Z",
			transform: "translate(-29.8602 -113.2903)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M348.1743,407.3033,264.2165,227.704a38,38,0,1,0-56.1224,0L124.1363,407.3033a13.2334,13.2334,0,0,0,6.3653,17.5407l8.7065,4.07a13.2334,13.2334,0,0,0,17.5407-6.3653L174.3019,385H298.0087l17.5531,37.5488a13.2333,13.2333,0,0,0,17.5406,6.3653l8.7066-4.07A13.2334,13.2334,0,0,0,348.1743,407.3033ZM259.2085,302H213.1021l23.0532-49.3145Zm-73.22,58,15.4266-33h69.48l15.4266,33Z",
			transform: "translate(-29.8602 -113.2903)"
		})
	);
};

Broadcast.defaultProps = {
	fill: "#000000",
	scale: 1
};

Broadcast.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$5 = styled.svg.withConfig({
	displayName: "Brush__Svg",
	componentId: "sc-1a21ppf-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Brush = function Brush(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$5,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1615 0q70 0 122.5 46.5t52.5 116.5q0 63-45 151-332 629-465 752-97 91-218 91-126 0-216.5-92.5t-90.5-219.5q0-128 92-212l638-579q59-54 130-54zm-909 1034q39 76 106.5 130t150.5 76l1 71q4 213-129.5 347t-348.5 134q-123 0-218-46.5t-152.5-127.5-86.5-183-29-220q7 5 41 30t62 44.5 59 36.5 46 17q41 0 55-37 25-66 57.5-112.5t69.5-76 88-47.5 103-25.5 125-10.5z"
		})
	);
};

Brush.defaultProps = {
	fill: "#000000",
	scale: 1
};

Brush.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$6 = styled.svg.withConfig({
	displayName: "Building__Svg",
	componentId: "sc-3ry7z1-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Building = function Building(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$6,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1472 0q26 0 45 19t19 45v1664q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h1280zm-832 288v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm0 256v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm0 256v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm0 256v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm-128 320v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm512 1280v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-512v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 1024v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23z"
		})
	);
};

Building.defaultProps = {
	fill: "#000000",
	scale: 1
};

Building.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$7 = styled.svg.withConfig({
	displayName: "Caret__Svg",
	componentId: "sc-1qpt1dl-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Caret = function Caret(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$7,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "240.8,390.4 475.6,172.3 406.6,98 240.4,252.3 74.3,98 5.3,172.3 "
		})
	);
};

Caret.defaultProps = {
	fill: "#000000",
	scale: 1
};

Caret.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$8 = styled.svg.withConfig({
	displayName: "Checkmark__Svg",
	componentId: "sc-m3a1lj-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Checkmark = function Checkmark(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$8,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 225.24 191.68", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M379,175c3,3,4,5,1,9-1.56,2.08-106.15,130.35-123,151-1.47,1.8-4,2-7,0s-89.78-73.06-91.09-74.33c-3.34-3.24-2.91-4.67.09-8.67,8.11-10.81,21.58-28,23.42-30.27,2.73-3.35,4-3.71,7.13-.87,3.33,3,49.95,42.64,49.95,42.64s94.77-112.15,97.64-115.82S342,144,345.5,146.5,377,173,379,175Z",
			transform: "translate(-156.57 -144.75)"
		})
	);
};

Checkmark.defaultProps = {
	fill: "#000000",
	scale: 1
};

Checkmark.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$9 = styled.svg.withConfig({
	displayName: "ChevronDown__Svg",
	componentId: "sc-1x0s0t4-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var ChevronDown = function ChevronDown(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$9,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 24 24", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z"
		})
	);
};

ChevronDown.defaultProps = {
	fill: "#000000",
	scale: 1
};

ChevronDown.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$a = styled.svg.withConfig({
	displayName: "ChevronRight__Svg",
	componentId: "sc-rxhgdd-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var ChevronRight = function ChevronRight(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$a,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 14.5 14.5", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M0.5,2.7L2,1.2l6,6l-6,6l-1.4-1.4l4.6-4.6L0.5,2.7 M6.5,2.7L8,1.2l6,6l-6,6l-1.4-1.4l4.6-4.6L6.5,2.7z"
		})
	);
};

ChevronRight.defaultProps = {
	fill: "#000000",
	scale: 1
};

ChevronRight.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$b = styled.svg.withConfig({
	displayName: "Clipboard__Svg",
	componentId: "sc-hsp01w-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Clipboard = function Clipboard(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$b,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 384 512", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
		})
	);
};

Clipboard.defaultProps = {
	fill: "#000000",
	scale: 1
};

Clipboard.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$c = styled.svg.withConfig({
	displayName: "Colorblind__Svg",
	componentId: "sc-1wd6bok-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Colorblind = function Colorblind(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$c,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M555 1335l78-141q-87-63-136-159t-49-203q0-121 61-225-229 117-381 353 167 258 427 375zm389-759q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm363-191q0 7-1 9-105 188-315 566t-316 567l-49 89q-10 16-28 16-12 0-134-70-16-10-16-28 0-12 44-87-143-65-263.5-173t-208.5-245q-20-31-20-69t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16 5 0 18 6t31 15.5 33 18.5 31.5 18.5 19.5 11.5q16 10 16 27zm37 447q0 139-79 253.5t-209 164.5l280-502q8 45 8 84zm448 128q0 35-20 69-39 64-109 145-150 172-347.5 267t-419.5 95l74-132q212-18 392.5-137t301.5-307q-115-179-282-294l63-112q95 64 182.5 153t144.5 184q20 34 20 69z"
		})
	);
};

Colorblind.defaultProps = {
	fill: "#000000",
	scale: 1
};

Colorblind.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$d = styled.svg.withConfig({
	displayName: "CogOutline__Svg",
	componentId: "sc-1s6jlz6-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var CogOutline = function CogOutline(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$d,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 19.5 20", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M9.7,6c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S7.5,6,9.7,6 M9.7,8c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S10.8,8,9.7,8 M7.7,20c-0.2,0-0.5-0.2-0.5-0.4l-0.4-2.6c-0.6-0.2-1.2-0.6-1.7-1l-2.5,1c-0.2,0.1-0.5,0-0.6-0.2l-2-3.5c-0.1-0.2-0.1-0.5,0.1-0.6 L2.3,11l-0.1-1l0.1-1L0.2,7.4C0,7.2-0.1,6.9,0.1,6.7l2-3.5C2.2,3.1,2.5,3,2.7,3.1l2.5,1c0.5-0.4,1.1-0.7,1.7-1l0.4-2.7 C7.3,0.2,7.5,0,7.7,0h4c0.2,0,0.5,0.2,0.5,0.4l0.4,2.7c0.6,0.2,1.2,0.6,1.7,1l2.5-1c0.2-0.1,0.5,0,0.6,0.2l2,3.5 c0.1,0.2,0.1,0.5-0.1,0.6L17.2,9l0.1,1l-0.1,1l2.1,1.6c0.2,0.1,0.2,0.4,0.1,0.6l-2,3.5C17.3,17,17,17,16.8,17l-2.5-1 c-0.5,0.4-1.1,0.7-1.7,1l-0.4,2.6c0,0.2-0.2,0.4-0.5,0.4H7.7 M9,2L8.6,4.6c-1.2,0.2-2.3,0.9-3,1.8l-2.4-1L2.4,6.6l2.1,1.6 c-0.4,1.2-0.4,2.4,0,3.6l-2.1,1.6l0.8,1.3l2.4-1c0.8,0.9,1.8,1.5,3,1.8L9,18h1.5l0.4-2.6c1.2-0.2,2.2-0.9,3-1.8l2.4,1l0.8-1.3 l-2.1-1.5c0.4-1.2,0.4-2.4,0-3.6L17,6.6l-0.8-1.3l-2.4,1c-0.8-0.9-1.8-1.5-3-1.8L10.5,2H9z"
		})
	);
};

CogOutline.defaultProps = {
	fill: "#000000",
	scale: 1
};

CogOutline.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$e = styled.svg.withConfig({
	displayName: "Collapse__Svg",
	componentId: "sc-1jbl7m2-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Collapse = function Collapse(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$e,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"
		})
	);
};

Collapse.defaultProps = {
	fill: "#000000",
	scale: 1
};

Collapse.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$f = styled.svg.withConfig({
	displayName: "ClearX__Svg",
	componentId: "sc-16aiqmk-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var ClearX = function ClearX(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$f,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 370.8 370.8", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M207.6,185.7l68.3-68.2c1.2-1.3,1.2-3.3,0-4.5l-17.4-17.4c-1.3-1.2-3.3-1.2-4.5,0l-68.2,68.3l-68.2-68.3 c-1.3-1.2-3.3-1.2-4.5,0L95.6,113c-1.2,1.3-1.2,3.3,0,4.5l68.3,68.2L95.6,254c-1.2,1.3-1.2,3.3,0,4.5l17.4,17.4 c1.3,1.2,3.3,1.2,4.5,0l68.2-68.3l68.2,68.3c1.3,1.2,3.3,1.2,4.5,0l17.4-17.4c1.2-1.3,1.2-3.3,0-4.5L207.6,185.7z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M185.7,27.3c42.3,0,82.1,16.5,112,46.4s46.4,69.7,46.4,112s-16.5,82.1-46.4,112s-69.7,46.4-112,46.4s-82.1-16.5-112-46.4 s-46.4-69.7-46.4-112s16.5-82.1,46.4-112S143.4,27.3,185.7,27.3 M185.7,0.3C83.3,0.3,0.3,83.3,0.3,185.7s83,185.4,185.4,185.4 s185.4-83,185.4-185.4S288.1,0.3,185.7,0.3L185.7,0.3z"
		})
	);
};

ClearX.defaultProps = {
	fill: "#000000",
	scale: 1
};

ClearX.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$g = styled.svg.withConfig({
	displayName: "ClosePin__Svg",
	componentId: "sc-s7y8q8-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var ClosePin = function ClosePin(props) {
	var backgroundFill = props.backgroundFill,
	    scale = props.scale,
	    xFill = props.xFill;

	return React.createElement(
		Svg$g,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 366 424", scale: scale },
		React.createElement("path", {
			fill: backgroundFill,
			d: "M362,181c0,137-181,243-181,243S0,318,0,181C0,81,81,0,181,0S362,81,362,181z"
		}),
		React.createElement("path", {
			fill: xFill,
			d: "M200.9,185.9l62.1-62.1c1.1-1.1,1.1-3,0-4.1l-15.8-15.8c-1.1-1.1-3-1.1-4.1,0L181,166l-62.1-62.1c-1.1-1.1-3-1.1-4.1,0 L99,119.7c-1.1,1.1-1.1,3,0,4.1l62.1,62.1L99,248c-1.1,1.1-1.1,3,0,4.1l15.8,15.8c1.1,1.1,3,1.1,4.1,0l62.1-62.1l62.1,62.1 c1.1,1.1,3,1.1,4.1,0l15.8-15.8c1.1-1.1,1.1-3,0-4.1L200.9,185.9z"
		})
	);
};

ClosePin.defaultProps = {
	backgroundFill: "#000000",
	scale: 1,
	xFill: "#ffffff"
};

ClosePin.propTypes = {
	backgroundFill: PropTypes.string,
	scale: PropTypes.number,
	xFill: PropTypes.string
};

var Svg$h = styled.svg.withConfig({
	displayName: "Copy__Svg",
	componentId: "sc-1xaa499-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Copy = function Copy(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$h,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 24 24", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
		})
	);
};

Copy.defaultProps = {
	fill: "#000000",
	scale: 1
};

Copy.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$i = styled.svg.withConfig({
	displayName: "Crosshairs__Svg",
	componentId: "sc-1aj0lia-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Crosshairs = function Crosshairs(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$i,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1325 1024h-109q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h109q-32-108-112.5-188.5t-188.5-112.5v109q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-109q-108 32-188.5 112.5t-112.5 188.5h109q26 0 45 19t19 45v128q0 26-19 45t-45 19h-109q32 108 112.5 188.5t188.5 112.5v-109q0-26 19-45t45-19h128q26 0 45 19t19 45v109q108-32 188.5-112.5t112.5-188.5zm339-192v128q0 26-19 45t-45 19h-143q-37 161-154.5 278.5t-278.5 154.5v143q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-143q-161-37-278.5-154.5t-154.5-278.5h-143q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h143q37-161 154.5-278.5t278.5-154.5v-143q0-26 19-45t45-19h128q26 0 45 19t19 45v143q161 37 278.5 154.5t154.5 278.5h143q26 0 45 19t19 45z"
		})
	);
};

Crosshairs.defaultProps = {
	fill: "#000000",
	scale: 1
};

Crosshairs.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$j = styled.svg.withConfig({
	displayName: "Data__Svg",
	componentId: "sc-uk2eha-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Data = function Data(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$j,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M896 768q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zm0 768q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zm0-384q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zm0-1152q208 0 385 34.5t280 93.5 103 128v128q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-128q0-69 103-128t280-93.5 385-34.5z"
		})
	);
};

Data.defaultProps = {
	fill: "#000000",
	scale: 1
};

Data.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$k = styled.svg.withConfig({
	displayName: "Dollar__Svg",
	componentId: "sc-wi0ina-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Dollar = function Dollar(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$k,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1362 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z"
		})
	);
};

Dollar.defaultProps = {
	fill: "#000000",
	scale: 1
};

Dollar.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$l = styled.svg.withConfig({
	displayName: "DotPyramid__Svg",
	componentId: "sc-150oi0a-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var DotPyramid = function DotPyramid(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$l,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1108.1466 927.9057", scale: scale },
		React.createElement("circle", { fill: fill, cx: "554.0733", cy: "151.1671", r: "151.1671" }),
		React.createElement("circle", { fill: fill, cx: "956.9794", cy: "776.7386", r: "151.1671" }),
		React.createElement("circle", { fill: fill, cx: "151.1671", cy: "776.7386", r: "151.1671" })
	);
};

DotPyramid.defaultProps = {
	fill: "#000000",
	scale: 1
};

DotPyramid.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$m = styled.svg.withConfig({
	displayName: "DotsHorizontal__Svg",
	componentId: "sc-jey2yu-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var DotsHorizontal = function DotsHorizontal(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$m,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 18 18", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M13,9c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S13,10.1,13,9 M7,9c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S7,10.1,7,9 M1,9 c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S1,10.1,1,9z"
		})
	);
};

DotsHorizontal.defaultProps = {
	fill: "#000000",
	scale: 1
};

DotsHorizontal.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$n = styled.svg.withConfig({
	displayName: "DotsVertical__Svg",
	componentId: "sc-1ul1jja-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var DotsHorizontal$1 = function DotsHorizontal(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$n,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 18 18", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M9,13c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S7.9,13,9,13 M9,7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S7.9,7,9,7 M9,1 c1.1,0,2,0.9,2,2s-0.9,2-2,2S7,4.1,7,3S7.9,1,9,1z"
		})
	);
};

DotsHorizontal$1.defaultProps = {
	fill: "#000000",
	scale: 1
};

DotsHorizontal$1.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$o = styled.svg.withConfig({
	displayName: "Download__Svg",
	componentId: "sc-b44tny-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Download = function Download(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$o,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z"
		})
	);
};

Download.defaultProps = {
	fill: "#000000",
	scale: 1
};

Download.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$p = styled.svg.withConfig({
	displayName: "DownloadImage__Svg",
	componentId: "sc-rahzf9-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var DownloadImage = function DownloadImage(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$p,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1194.3114 1764.921", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1408.91,794.0471H1275.4719l-82.5337,82.5337H1408.91a18.8038,18.8038,0,0,1,13.9958,6.1256,20.1917,20.1917,0,0,1,5.9093,14.5078v784.0709a20.1921,20.1921,0,0,1-5.9093,14.5079,18.8037,18.8037,0,0,1-13.9958,6.1255H413.6508a18.804,18.804,0,0,1-13.9958-6.1255,20.1925,20.1925,0,0,1-5.9093-14.5079V897.2142a20.1922,20.1922,0,0,1,5.9093-14.5078,18.8041,18.8041,0,0,1,13.9958-6.1256H629.6229l-82.5337-82.5337H413.6508q-41.0544,0-70.29,30.3053t-29.2358,72.8618v784.0709q0,42.5565,29.2358,72.8618t70.29,30.3054h995.26q41.0544,0,70.29-30.3054t29.2359-72.8618V897.2142q0-42.5563-29.2359-72.8618T1408.91,794.0471Z",
			transform: "translate(-314.1249 -19.5312)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M508.2005,995.2231q-34.834,36.1086-34.8341,87.6921t34.8341,87.6922q34.834,36.1084,84.597,36.1085t84.5971-36.1085q34.8341-36.1086,34.8341-87.6922t-34.8341-87.6921q-34.834-36.1085-84.5971-36.1085T508.2005,995.2231Z",
			transform: "translate(-314.1249 -19.5312)"
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "159.242 1599.854 1035.07 1599.854 1035.07 1310.985 776.302 1042.751 457.819 1372.886 358.293 1269.718 159.242 1476.053 159.242 1599.854"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1335.3548,480.4088q14.22,34.2939-11.71,58.5507L948.92,913.6839q-15.0559,15.8922-37.64,15.8923t-37.64-15.8923L498.9164,538.96q-25.9294-24.2568-11.71-58.5507,14.22-32.6211,49.35-32.6211H750.6844V73.0633q0-21.7474,15.8923-37.64t37.64-15.8924h214.1282q21.7475,0,37.64,15.8924t15.8923,37.64V447.7877H1286.005Q1321.1353,447.7877,1335.3548,480.4088Z",
			transform: "translate(-314.1249 -19.5312)"
		})
	);
};

DownloadImage.defaultProps = {
	fill: "#000000",
	scale: 1
};

DownloadImage.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$q = styled.svg.withConfig({
	displayName: "Envelope__Svg",
	componentId: "sc-px1oog-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Envelope = function Envelope(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$q,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1664 1504v-768q-32 36-69 66-268 206-426 338-51 43-83 67t-86.5 48.5-102.5 24.5h-2q-48 0-102.5-24.5t-86.5-48.5-83-67q-158-132-426-338-37-30-69-66v768q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zm0-1051v-24.5l-.5-13-3-12.5-5.5-9-9-7.5-14-2.5h-1472q-13 0-22.5 9.5t-9.5 22.5q0 168 147 284 193 152 401 317 6 5 35 29.5t46 37.5 44.5 31.5 50.5 27.5 43 9h2q20 0 43-9t50.5-27.5 44.5-31.5 46-37.5 35-29.5q208-165 401-317 54-43 100.5-115.5t46.5-131.5zm128-37v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
		})
	);
};

Envelope.defaultProps = {
	fill: "#000000",
	scale: 1
};

Envelope.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$r = styled.svg.withConfig({
	displayName: "Expand__Svg",
	componentId: "sc-6k2w72-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Expand = function Expand(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$r,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M883 1056q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23zm781-864v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45z"
		})
	);
};

Expand.defaultProps = {
	fill: "#000000",
	scale: 1
};

Expand.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$s = styled.svg.withConfig({
	displayName: "File__Svg",
	componentId: "sc-1p30tp5-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var File = function File(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$s,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z"
		})
	);
};

File.defaultProps = {
	fill: "#000000",
	scale: 1
};

File.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$t = styled.svg.withConfig({
	displayName: "Filter__Svg",
	componentId: "sc-1nptlz0-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Filter = function Filter(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$t,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1410.0417 1408", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1595,295q17,41-14,70L1088,858v742q0,42-39,59a69.5355,69.5355,0,0,1-25,5q-27,0-45-19L723,1389q-19-19-19-45V858L211,365q-31-29-14-70,17-39,59-39H1536Q1578,256,1595,295Z",
			transform: "translate(-190.9792 -256)"
		})
	);
};

Filter.defaultProps = {
	fill: "#000000",
	scale: 1
};

Filter.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$u = styled.svg.withConfig({
	displayName: "FilterSettingsOutline__Svg",
	componentId: "sc-15ri2ji-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var FilterSettingsOutline = function FilterSettingsOutline(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$u,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 24 24", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M15,21.5h2v2h-2 M11,21.5h2v2h-2 M7,21.5h2v2H7 M15,19.4c0,0.3-0.1,0.6-0.3,0.8c-0.4,0.4-1,0.4-1.4,0l-4-4 C9.1,16,9,15.7,9,15.4v-5.1L4.2,4.1C3.9,3.7,4,3.1,4.4,2.7C4.6,2.6,4.8,2.5,5,2.5h14c0.2,0,0.4,0.1,0.6,0.2c0.4,0.3,0.5,1,0.2,1.4 L15,10.2V19.4 M7,4.5l4,5.1v5.5l2,2V9.5l4-5H7z"
		})
	);
};

FilterSettingsOutline.defaultProps = {
	fill: "#000000",
	scale: 1
};

FilterSettingsOutline.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$v = styled.svg.withConfig({
	displayName: "FilterOutline__Svg",
	componentId: "sc-1af8u8k-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var FilterOutline = function FilterOutline(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$v,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 24 24", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z"
		})
	);
};

FilterOutline.defaultProps = {
	fill: "#000000",
	scale: 1
};

FilterOutline.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$w = styled.svg.withConfig({
	displayName: "Flame__Svg",
	componentId: "sc-1ho5u5k-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Flame = function Flame(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$w,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M374.5,127.5c-20,76-76,87-76,87,37-140-74-192-74-192,38,98-11.3972,133.3136-77.5,185.5-57,45-55,128,13,166,67.6883,37.8258,81,79,81,79,60-88,76.7876-55.9906,121-123C426,233,374.5,127.5,374.5,127.5ZM243.8687,424S252.7341,384.2338,204,357c-48.9585-27.3592-43.6631-68.1711-11-109,24-30,50-44,50-44s-23.5461,75.7182-3,100c22,26,71-8,71-8C311,354,279,353,243.8687,424Z"
		})
	);
};

Flame.defaultProps = {
	fill: "#000000",
	scale: 1
};

Flame.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$x = styled.svg.withConfig({
	displayName: "Gear__Svg",
	componentId: "sc-1fjrs9z-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Gear = function Gear(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$x,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z"
		})
	);
};

Gear.defaultProps = {
	fill: "#000000",
	scale: 1
};

Gear.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$y = styled.svg.withConfig({
	displayName: "Image__Svg",
	componentId: "sc-14v2vnu-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Image = function Image(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$y,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "-100 0 2000 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
		})
	);
};

Image.defaultProps = {
	fill: "#000000",
	scale: 1
};

Image.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$z = styled.svg.withConfig({
	displayName: "info__Svg",
	componentId: "sc-12kkpk6-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Info = function Info(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$z,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1024 1376v-192q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v192q0 14 9 23t23 9h192q14 0 23-9t9-23zm256-672q0-88-55.5-163t-138.5-116-170-41q-243 0-371 213-15 24 8 42l132 100q7 6 19 6 16 0 25-12 53-68 86-92 34-24 86-24 48 0 85.5 26t37.5 59q0 38-20 61t-68 45q-63 28-115.5 86.5t-52.5 125.5v36q0 14 9 23t23 9h192q14 0 23-9t9-23q0-19 21.5-49.5t54.5-49.5q32-18 49-28.5t46-35 44.5-48 28-60.5 12.5-81zm384 192q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
		})
	);
};

Info.defaultProps = {
	fill: "#000000",
	scale: 1
};

Info.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$A = styled.svg.withConfig({
	displayName: "InfoDot__Svg",
	componentId: "sc-djdpf4-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Info$1 = function Info(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$A,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M240.1,1.3c-132,0-239,107-239,239s107,239,239,239s239-107,239-239S372.1,1.3,240.1,1.3z M240.5,433.8C133.6,433.8,47,347.2,47,240.3S133.6,46.8,240.5,46.8S434,133.5,434,240.3S347.4,433.8,240.5,433.8z"
		}),
		React.createElement("circle", { fill: fill, cx: "240.3", cy: "140.3", r: "33.3" }),
		React.createElement("path", {
			fill: fill,
			d: "M309.2,353.9c0,10.3-8.5,18.8-18.8,18.8h-88.6c-10.3,0-18.8-8.5-18.8-18.8V334c0-10.3,8.5-18.8,18.8-18.8h16.5v-58.5h-6.1c-10.5,0-19.1-8.6-19.1-19.1v-19.3c0-10.5,8.6-19.1,19.1-19.1h42.8c8.7,0,16.1,6,18.4,14h0.7v5v19.3v77.5h16.3c10.3,0,18.8,8.5,18.8,18.8V353.9z"
		})
	);
};

Info$1.defaultProps = {
	fill: "#000000",
	scale: 1
};

Info$1.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$B = styled.svg.withConfig({
	displayName: "LightUI__Svg",
	componentId: "sc-1u3stox-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var LightUI = function LightUI(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$B,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement(
			"g",
			null,
			React.createElement("path", {
				fill: fill,
				d: "M411.1,34.8H68.4c-18.5,0-33.6,15.1-33.6,33.6v342.8c0,18.5,15.1,33.6,33.6,33.6h342.8c18.5,0,33.6-15.1,33.6-33.6V68.4 C444.8,49.9,429.6,34.8,411.1,34.8z M412.2,397.7c0,8-6.5,14.5-14.5,14.5h-316c-8,0-14.5-6.5-14.5-14.5v-316 c0-8,6.5-14.5,14.5-14.5h316c8,0,14.5,6.5,14.5,14.5V397.7z"
			})
		),
		React.createElement("path", {
			fill: fill,
			d: "M165,361c-4.8,0-9.4-2.3-12.3-6.4l-45-64c-4.8-6.8-3.1-16.1,3.6-20.9c6.8-4.8,16.1-3.1,20.9,3.6l28.3,40.3L221.9,142 c1.9-5.4,6.8-9.2,12.4-9.9c5.7-0.6,11.3,2,14.3,6.8l62.1,97.5l52.8-51.2c5.9-5.8,15.4-5.6,21.2,0.3c5.8,5.9,5.6,15.4-0.3,21.2 l-66,64c-3.2,3.1-7.7,4.7-12.2,4.1c-4.5-0.5-8.5-3-10.9-6.8l-55.5-87.1L179.1,351c-1.9,5.3-6.6,9.1-12.1,9.8 C166.3,361,165.7,361,165,361z"
		}),
		React.createElement(
			"g",
			{ style: { display: "none" } },
			React.createElement("path", {
				style: { display: "inline" },
				d: "M411.1,34.8H68.4c-18.5,0-33.6,15.1-33.6,33.6v342.8c0,18.5,15.1,33.6,33.6,33.6h342.8 c18.5,0,33.6-15.1,33.6-33.6V68.4C444.8,49.9,429.6,34.8,411.1,34.8z M384.4,206.8l-66,64c-3.2,3.1-7.7,4.7-12.2,4.1 c-4.5-0.5-8.5-3-10.9-6.8l-55.5-87.1L179.1,351c-1.9,5.3-6.6,9.1-12.1,9.8c-0.7,0.1-1.4,0.1-2,0.1c-4.8,0-9.4-2.3-12.3-6.4l-45-64 c-4.8-6.8-3.1-16.1,3.6-20.9c6.8-4.8,16.1-3.1,20.9,3.6l28.3,40.3L221.9,142c1.9-5.4,6.8-9.2,12.4-9.9c5.7-0.6,11.3,2,14.3,6.8 l62.1,97.5l52.8-51.2c5.9-5.8,15.4-5.6,21.2,0.3C390.5,191.5,390.4,201,384.4,206.8z"
			})
		)
	);
};

LightUI.defaultProps = {
	fill: "#000000",
	scale: 1
};

LightUI.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$C = styled.svg.withConfig({
	displayName: "Line__Svg",
	componentId: "sc-nptsfr-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Line = function Line(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$C,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1013.7,1163.1 1392.5,859.3 1596.9,1003.9 1776.9,948.1 1776.9,808.3 1607.5,865.8 1380.6,691.9 1024.7,988.4 460.5,424.3 21.7,988.4 21.7,1192.3 468,618.5 "
		})
	);
};

Line.defaultProps = {
	fill: "#000000",
	scale: 1
};

Line.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$D = styled.svg.withConfig({
	displayName: "Link__Svg",
	componentId: "sc-czbz2l-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Link = function Link(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$D,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"
		})
	);
};

Link.defaultProps = {
	fill: "#000000",
	scale: 1
};

Link.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$E = styled.svg.withConfig({
	displayName: "LineChart__Svg",
	componentId: "sc-xz3rpi-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var LineChart = function LineChart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$E,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1776.9,1447 1776.9,1557.1 15.7,1557.1 15.7,236.2 125.8,236.2 125.8,1447 "
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "1106.8,994.9 1374,783.2 1538.5,1337 1666.8,1337 1446.7,566.4 1116.5,841.6 621.1,346.3 235.9,841.6 235.9,1020.6 627.7,516.8 "
		})
	);
};

LineChart.defaultProps = {
	fill: "#000000",
	scale: 1
};

LineChart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$F = styled.svg.withConfig({
	displayName: "LineChartDashed__Svg",
	componentId: "sc-1bsj5n0-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var LineChartDashed = function LineChartDashed(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$F,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1572.9705 1306.9585", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1540.835 1198.045 1540.835 1306.959 0 1306.959 0 0 108.913 0 108.913 1198.045 1540.835 1198.045"
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "1090.208 598.126 1089.132 599.023 599.023 108.913 217.826 599.023 217.826 776.064 605.518 277.604 1079.588 750.653 1148.302 696.212 1090.208 598.126"
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "1361.113 526.28 1300.946 424.694 1239.734 475.705 1298.887 575.58 1361.113 526.28"
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "1572.971 353.861 1512.804 252.276 1451.591 303.286 1510.745 403.161 1572.971 353.861"
		})
	);
};

LineChartDashed.defaultProps = {
	fill: "#000000",
	scale: 1
};

LineChartDashed.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$G = styled.svg.withConfig({
	displayName: "List__Svg",
	componentId: "sc-1x7s8b8-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var List = function List(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$G,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"
		})
	);
};

List.defaultProps = {
	fill: "#000000",
	scale: 1
};

List.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$H = styled.svg.withConfig({
	displayName: "ListBoxOutline__Svg",
	componentId: "sc-gzox44-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var ListBoxOutline = function ListBoxOutline(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$H,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 20 20", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M9,13h6v2H9V13 M7,5H5v2h2V5 M9,11h6V9H9V11 M9,7h6V5H9V7 M7,9H5v2h2V9 M19,3v14c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V3 c0-1.1,0.9-2,2-2h14C18.1,1,19,1.9,19,3 M17,3H3v14h14V3 M7,13H5v2h2V13z"
		})
	);
};

ListBoxOutline.defaultProps = {
	fill: "#000000",
	scale: 1
};

ListBoxOutline.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$I = styled.svg.withConfig({
	displayName: "Lock__Svg",
	componentId: "sc-1rdbanm-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Lock = function Lock(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$I,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"
		})
	);
};

Lock.defaultProps = {
	fill: "#000000",
	scale: 1
};

Lock.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$J = styled.svg.withConfig({
	displayName: "LogChart__Svg",
	componentId: "sc-1244trm-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var LogChart = function LogChart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$J,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1776.9,1447 1776.9,1557.1 15.7,1557.1 15.7,236.2 125.8,236.2 125.8,1447 "
		}),
		React.createElement("path", {
			fill: fill,
			d: "M379.7,1323.9v-0.2h-120c0-2.8,0.3-68.8,22.8-165.6c13.1-56.2,31-111.8,53.4-165.4c28-67,63.1-130.8,104.2-189.7 c104.5-149.8,247.8-269,426.1-354.2c104.6-50,222.5-88.6,350.3-114.8c139.3-28.5,294-43,459.8-43v120 c-298.4,0-552.2,48.5-754.4,144.2C762.7,630.5,634.9,735.3,542,866.6c-36.6,51.7-67.8,107.7-92.9,166.5 c-20.2,47.3-36.5,96.6-48.4,146.4C380.2,1265.1,379.7,1323.3,379.7,1323.9z"
		})
	);
};

LogChart.defaultProps = {
	fill: "#000000",
	scale: 1
};

LogChart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$K = styled.svg.withConfig({
	displayName: "MapPin__Svg",
	componentId: "sc-ftaul9-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var MapPin = function MapPin(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$K,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1152 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm256 0q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z"
		})
	);
};

MapPin.defaultProps = {
	fill: "#000000",
	scale: 1
};

MapPin.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$L = styled.svg.withConfig({
	displayName: "MeatballSub__Svg",
	componentId: "sc-kbk091-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var MeatballSub = function MeatballSub(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$L,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 477.2393 477.2393", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M239.8823,1.8635c-131.786,0-238.62,106.8337-238.62,238.62s106.8337,238.62,238.62,238.62,238.62-106.8336,238.62-238.62S371.6683,1.8635,239.8823,1.8635ZM99.2564,285.7388a45.2556,45.2556,0,1,1,45.2556-45.2556A45.2556,45.2556,0,0,1,99.2564,285.7388Zm140.6259,0a45.2556,45.2556,0,1,1,45.2556-45.2556A45.2556,45.2556,0,0,1,239.8823,285.7388Zm140.6259,0a45.2556,45.2556,0,1,1,45.2556-45.2556A45.2556,45.2556,0,0,1,380.5082,285.7388Z",
			transform: "translate(-1.2626 -1.8635)"
		})
	);
};

MeatballSub.defaultProps = {
	fill: "#000000",
	scale: 1
};

MeatballSub.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$M = styled.svg.withConfig({
	displayName: "Microphone__Svg",
	componentId: "sc-19x7rkr-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Microphone = function Microphone(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$M,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1472 704v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-217-24-364.5-187.5t-147.5-384.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45zm-256-384v512q0 132-94 226t-226 94-226-94-94-226v-512q0-132 94-226t226-94 226 94 94 226z"
		})
	);
};

Microphone.defaultProps = {
	fill: "#000000",
	scale: 1
};

Microphone.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$N = styled.svg.withConfig({
	displayName: "MicrophoneO__Svg",
	componentId: "sc-190co2l-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var MicrophoneO = function MicrophoneO(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$N,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1472,704v128c0,147.3-49.2,275.5-147.5,384.5S1104.7,1388,960,1404v132h256c17.3,0,32.3,6.3,45,19 s19,27.7,19,45s-6.3,32.3-19,45s-27.7,19-45,19H576c-17.3,0-32.3-6.3-45-19s-19-27.7-19-45s6.3-32.3,19-45s27.7-19,45-19h256v-132 c-144.7-16-266.2-78.5-364.5-187.5S320,979.3,320,832V704c0-17.3,6.3-32.3,19-45s27.7-19,45-19s32.3,6.3,45,19s19,27.7,19,45v128 c0,123.3,43.8,228.8,131.5,316.5S772.7,1280,896,1280s228.8-43.8,316.5-131.5S1344,955.3,1344,832V704c0-17.3,6.3-32.3,19-45 s27.7-19,45-19s32.3,6.3,45,19S1472,686.7,1472,704z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1122,94C1059.3,31.3,984,0,896,0S732.7,31.3,670,94s-94,138-94,226v512c0,88,31.3,163.3,94,226s138,94,226,94 s163.3-31.3,226-94s94-138,94-226V320C1216,232,1184.7,156.7,1122,94z M1107.8,811.6c0,62.3-20.8,115.7-62.3,160 c-41.5,44.4-91.4,66.6-149.7,66.6c-58.3,0-108.2-22.2-149.7-66.6c-41.5-44.4-62.3-97.7-62.3-160V338.8c0-62.3,20.8-115.7,62.3-160 c41.5-44.4,91.4-66.6,149.7-66.6c58.3,0,108.2,22.2,149.7,66.6c41.5,44.4,62.3,97.7,62.3,160V811.6z"
		})
	);
};

MicrophoneO.defaultProps = {
	fill: "#000000",
	scale: 1
};

MicrophoneO.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$O = styled.svg.withConfig({
	displayName: "Microscope__Svg",
	componentId: "sc-1e11ngr-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Microscope = function Microscope(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$O,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement(
			"g",
			null,
			React.createElement("path", {
				fill: fill,
				d: "M367,288.8c0,5.6-4.5,10-10,10h-150c-5.5,0-10-4.5-10-10l0,0c0-5.5,4.5-10,10-10h150 C362.6,278.7,367,283.2,367,288.8L367,288.8z"
			}),
			React.createElement("path", {
				fill: fill,
				d: "M74.2,466.8H414c0-28.7-52.2-52.8-123.4-60.3c0.1-0.5,0.1-1,0.1-1.5v-71.1c0-6.3-5.1-11.5-11.4-11.5h-55.9 c-24.1-2.7-46-15-58.6-31.6c-11.3,14.7-29,24.3-48.9,24.3c-12.5,0-24.2-3.8-33.9-10.3c18.5,48.2,65.4,85.6,121.9,95.4v4.7 c0,0.3,0.1,0.5,0.1,0.8C129.5,412.5,74.2,437.3,74.2,466.8z"
			}),
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M198.2,25.3l-7.5-11.6c-1.7-2.7-5.2-3.4-7.9-1.7L141,39.1c-2.6,1.7-3.4,5.3-1.7,7.9l7.5,11.6L198.2,25.3z"
				}),
				React.createElement("path", {
					fill: fill,
					d: "M315.8,208.5l7.5,11.6c1.7,2.7,1,6.2-1.7,7.9l-41.9,27.2c-2.6,1.7-6.2,1-7.9-1.7l-7.5-11.6L315.8,208.5z"
				}),
				React.createElement("path", {
					fill: fill,
					d: "M315.5,184.3L220,35.5c-3.4-5.3-10.5-6.8-15.7-3.4l-53.8,35c-5.3,3.4-6.8,10.5-3.4,15.8l20.9,32.5 c-41,16.9-72.4,48.6-86.3,86.3c9.8-6.6,21.7-10.5,34.4-10.5c19.6,0,37.1,9.3,48.4,23.7c10.5-14.1,27.7-25.2,48.1-30l30.1,46.8 c3.4,5.3,10.5,6.8,15.7,3.4l53.8-35C317.4,196.7,318.9,189.6,315.5,184.3z"
				})
			),
			React.createElement("path", {
				fill: fill,
				d: "M154.4,236.7c-6.4-15-21.2-25.5-38.4-25.5c-23.1,0-41.8,18.8-41.8,42c0,23.2,18.7,42,41.8,42 c17.4,0,32.3-10.7,38.6-26c2-4.9,3.2-10.4,3.2-16C157.7,247.3,156.5,241.8,154.4,236.7z"
			})
		)
	);
};

Microscope.defaultProps = {
	fill: "#000000",
	scale: 1
};

Microscope.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$P = styled.svg.withConfig({
	displayName: "Newspaper__Svg",
	componentId: "sc-hnlm6-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Newspaper = function Newspaper(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$P,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M888.1,556.7H619.3v393h268.9v-393H888.1z M1010.7,1211.8v131h-514v-131H1010.7z M1010.7,425.7v655.1h-514 V425.7H1010.7z M1540.9,1211.8v131h-407.8v-131H1540.9z M1540.9,949.7v131h-407.8v-131H1540.9z M1540.9,687.8v131h-407.8v-131 H1540.9z M1540.9,425.7v131h-407.8v-131H1540.9z M251.7,1408.3V425.7H129.1v982.5c0,17.8,6,33.1,18.2,46.1s26.5,19.4,43.1,19.4 s31-6.4,43.1-19.4C245.7,1441.4,251.7,1426.1,251.7,1408.3z M1663.5,1408.3V294.8H374.2v1113.5c0,22.5-3.5,44.4-10.5,65.5h1238.5 c16.6,0,31-6.4,43.1-19.4C1657.5,1441.4,1663.5,1426.1,1663.5,1408.3z M1786,163.8v1244.6c0,54.5-17.8,101-53.6,139.2 c-35.7,38.2-79.1,57.3-130.1,57.3H190.4c-51,0-94.5-19.1-130.1-57.3c-35.7-38.2-53.6-84.6-53.6-139.2V294.8h245.1v-131H1786z"
		})
	);
};

Newspaper.defaultProps = {
	fill: "#000000",
	scale: 1
};

Newspaper.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$Q = styled.svg.withConfig({
	displayName: "NewspaperPin__Svg",
	componentId: "sc-1kug5lq-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var NewspaperPin = function NewspaperPin(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$Q,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M978.4,1239.4c-14.1,3.3-28.6,5-43.4,5c-35.3,0-68.6-9.3-99.1-27.7c-19.8-11.9-36.5-26.7-50.1-44.3H646.2V886.5l-74.9-158.9 h-29.1v556h436.3V1239.4z"
		}),
		React.createElement("rect", { fill: fill, x: "542.1", y: "1394.8", width: "436.3", height: "111.2" }),
		React.createElement("path", {
			fill: fill,
			d: "M1388.9,505.3c-5.4,32.2-14.2,61.3-26.4,87.1l-11.3,24.1h181.3v945.1c0,15.1-5.1,28.1-15.4,39.1 c-10.3,11-22.5,16.5-36.6,16.5H429.3c5.9-17.9,8.9-36.5,8.9-55.6V616.5h80.7l-11.4-24.1c-12.2-25.8-21-54.9-26.4-87.1H334.3v111.2 h-208v945.2c0,46.3,15.2,85.7,45.5,118.1c30.2,32.4,67.1,48.6,110.4,48.6h1198.3c43.3,0,80.1-16.2,110.4-48.6 c30.4-32.4,45.5-71.9,45.5-118.1V505.3l0,0H1388.9z M334.2,1561.6c0,15.1-5.1,28.1-15.4,39c-10.3,11-22.5,16.5-36.6,16.5 s-26.2-5.4-36.6-16.5s-15.4-24-15.4-39.1V727.6h104.1V1561.6z"
		}),
		React.createElement("polygon", { fill: fill, points: "1428.4,950.1 1194.3,950.1 1142,1061.3 1428.4,1061.3 " }),
		React.createElement("polygon", { fill: fill, points: "1428.4,727.6 1298.9,727.6 1246.6,838.8 1428.4,838.8 " }),
		React.createElement("path", {
			fill: fill,
			d: "M1428.4,1172.4L1428.4,1172.4l-343.9,0c-0.7,0.9-1.5,1.8-2.2,2.7v108.4h346.1V1172.4z"
		}),
		React.createElement("rect", { fill: fill, x: "1082.3", y: "1394.8", width: "346.1", height: "111.2" }),
		React.createElement("path", {
			fill: fill,
			d: "M1115.1,423.8c0-49.7-17.6-92.2-52.8-127.4c-35.2-35.2-77.6-52.8-127.4-52.8c-49.7,0-92.2,17.6-127.4,52.8 c-35.2,35.2-52.8,77.6-52.8,127.4s17.6,92.2,52.8,127.4c35.2,35.2,77.6,52.8,127.4,52.8c49.7,0,92.2-17.6,127.4-52.8 C1097.6,516,1115.1,473.5,1115.1,423.8z M1295.3,423.8c0,51.1-7.7,93.1-23.2,126l-256.1,544.6c-7.5,15.5-18.6,27.7-33.4,36.6 s-30.6,13.4-47.5,13.4s-32.7-4.5-47.5-13.4s-25.7-21.1-32.7-36.6L598,549.8c-15.5-32.8-23.2-74.8-23.2-126 c0-99.4,35.2-184.4,105.5-254.7S835.6,63.5,935,63.5s184.4,35.2,254.7,105.5C1260.1,239.5,1295.3,324.4,1295.3,423.8z"
		})
	);
};

NewspaperPin.defaultProps = {
	fill: "#000000",
	scale: 1
};

NewspaperPin.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$R = styled.svg.withConfig({
	displayName: "NewspaperStack__Svg",
	componentId: "sc-19u53j3-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var NewspaperStack = function NewspaperStack(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$R,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1636.9501 1230.8235", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1458.625,244.6416V9.3716H191.5579V99.8763H10.5482V869.1671q0,56.5654,39.596,96.1618t96.1613,39.5958h53.1159v99.5127q0,56.5656,39.596,96.1618t96.1613,39.5959H1511.7405q56.5656,0,96.162-39.5959t39.5958-96.1618V244.6422ZM191.5579,869.1672q0,18.3837-13.4343,31.8181T146.3056,914.42q-18.3838,0-31.8182-13.4343h0q-13.4339-13.4346-13.4339-31.8182V190.3811h90.5047Zm90.5047,0V99.8763H1368.12V869.1671q0,18.3837-13.4344,31.8181T1322.8679,914.42H274.2849A134.3425,134.3425,0,0,0,282.0626,869.1672Zm98.3676,235.27q0,18.3835-13.434,31.8177l0,0q-13.4341,13.4342-31.818,13.4342T303.36,1136.2549q-13.4345-13.4344-13.4343-31.8181v-99.5121H380.43Zm1176.5627,0q0,18.3837-13.4343,31.818t-31.8181,13.4343H463.1577a134.3425,134.3425,0,0,0,7.7777-45.2523v-99.5127h851.9324q56.5656,0,96.1619-39.5958t39.5953-96.1617V335.1463h98.3684Z",
			transform: "translate(-10.5482 -9.3716)"
		}),
		React.createElement("rect", { fill: fill, x: "362.0192", y: "724.0383", width: "452.524", height: "90.5049" }),
		React.createElement("path", {
			fill: fill,
			d: "M372.5675,642.9051H825.0914V190.3811H372.5675Zm90.5047-362.0192H734.5871V552.4H463.0722Z",
			transform: "translate(-10.5482 -9.3716)"
		}),
		React.createElement("rect", { fill: fill, x: "905.0481", y: "362.0193", width: "362.0193", height: "90.5047" }),
		React.createElement("rect", { fill: fill, x: "905.0481", y: "724.0383", width: "362.0193", height: "90.5049" }),
		React.createElement("rect", { fill: fill, x: "905.0481", y: "181.0095", width: "362.0193", height: "90.5049" }),
		React.createElement("rect", { fill: fill, x: "905.0481", y: "543.0288", width: "362.0193", height: "90.5049" })
	);
};

NewspaperStack.defaultProps = {
	fill: "#000000",
	scale: 1
};

NewspaperStack.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$S = styled.svg.withConfig({
	displayName: "Note__Svg",
	componentId: "sc-1m1xjq7-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Note = function Note(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$S,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M355.5,254.5v142.1c0,8.1-6.6,14.8-14.8,14.8H45.6c-8.1,0-14.8-6.6-14.8-14.8V112.1c0-8.1,6.6-14.8,14.8-14.8h205.7c6.9-5.8,14-11.8,21-17.7H45.6c-17.9,0-32.5,14.6-32.5,32.5v284.6c0,17.9,14.6,32.5,32.5,32.5h295.2c17.9,0,32.5-14.6,32.5-32.5V239.5C367.3,244.6,361.3,249.6,355.5,254.5z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M335.6,54.7c-55.7,47-156.4,132-156.4,132l-0.5,1.9L228,197l0,0l0,0l0,47.2l41.5,7.1l0,0l0,0l0,43.8l1.1-0.1c0,0,102.3-86.3,156.4-132L335.6,54.7z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M443.6,149c11.6-9.8,19.4-16.4,21.1-17.8c9-7.6,12.5-15.7,2.3-27.7c-7.6-9-59.7-70.7-67.4-79.9c-7.8-9.2-17.3-8.3-23.3-3.2c-1.2,1-10.4,8.8-24.1,20.3L443.6,149z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M190.1,276.2c-9.8-11.6-20.2-18.7-29.2-23.1l-14.5,53.5l58.8-5.6C202,293.1,197.2,284.6,190.1,276.2z"
		})
	);
};

Note.defaultProps = {
	fill: "#000000",
	scale: 1
};

Note.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$T = styled.svg.withConfig({
	displayName: "OpenInNew__Svg",
	componentId: "sc-1rylzgi-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var OpenInNew = function OpenInNew(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$T,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 24 24", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
		})
	);
};

OpenInNew.defaultProps = {
	fill: "#000000",
	scale: 1
};

OpenInNew.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$U = styled.svg.withConfig({
	displayName: "Palette__Svg",
	componentId: "sc-193xfyu-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Palette = function Palette(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$U,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 512 512", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
		})
	);
};

Palette.defaultProps = {
	fill: "#000000",
	scale: 1
};

Palette.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$V = styled.svg.withConfig({
	displayName: "Pause__Svg",
	componentId: "sc-hhuims-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Pause = function Pause(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$V,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1664 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zm-896 0v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z"
		})
	);
};

Pause.defaultProps = {
	fill: "#000000",
	scale: 1
};

Pause.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$W = styled.svg.withConfig({
	displayName: "Pencil__Svg",
	componentId: "sc-157uq12-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Pencil = function Pencil(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$W,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement(
			"g",
			null,
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M283.2,80.2C206.3,145.1,67.3,262.4,67.3,262.4l-0.7,2.6l68.1,11.6l0,0l0,0v65.2l57.3,9.8l0,0l0,0v60.5l1.5-0.1 c0,0,141.2-119.1,215.9-182.2L283.2,80.2z"
				})
			),
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M432.3,210.4c16-13.5,26.8-22.6,29.1-24.6c12.4-10.5,17.3-21.7,3.2-38.2c-10.5-12.4-82.4-97.6-93.1-110.3 c-10.8-12.7-23.9-11.5-32.2-4.4c-1.7,1.4-14.4,12.1-33.3,28L432.3,210.4z"
				})
			),
			React.createElement(
				"g",
				null,
				React.createElement("path", {
					fill: fill,
					d: "M82.3,386c-13.5-16-27.9-25.8-40.3-31.9L22,428l81.2-7.7C98.8,409.3,92.1,397.6,82.3,386z"
				})
			)
		)
	);
};

Pencil.defaultProps = {
	fill: "#000000",
	scale: 1
};

Pencil.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$X = styled.svg.withConfig({
	displayName: "Play__Svg",
	componentId: "sc-1a0ipdb-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Play = function Play(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$X,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1576 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z"
		})
	);
};

Play.defaultProps = {
	fill: "#000000",
	scale: 1
};

Play.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$Y = styled.svg.withConfig({
	displayName: "PlayCircle__Svg",
	componentId: "sc-13zjngx-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var PlayCircle = function PlayCircle(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$Y,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zm384 823q32-18 32-55t-32-55l-544-320q-31-19-64-1-32 19-32 56v640q0 37 32 56 16 8 32 8 17 0 32-9z"
		})
	);
};

PlayCircle.defaultProps = {
	fill: "#000000",
	scale: 1
};

PlayCircle.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$Z = styled.svg.withConfig({
	displayName: "Plus__Svg",
	componentId: "sc-1wjb3cw-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Plus = function Plus(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$Z,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 16 16", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M15,9H9v6H7V9H1V7h6V1h2v6h6V9z"
		})
	);
};

Plus.defaultProps = {
	fill: "#000000",
	scale: 1
};

Plus.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$_ = styled.svg.withConfig({
	displayName: "Quote__Svg",
	componentId: "sc-1gz39r-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Quote = function Quote(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$_,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M230.6,244c-10.5,164.8-184,186.7-172.1,181.5C243,344.5,174,184.5,174,184.5s-8,40-50,53c-36,11.1-98-14-98-78 c0-58.6,42-97,88.3-97c25.7,0,51.5,11.2,70.8,31.9C212,123.5,235,175.5,230.6,244z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M455.6,244c-10.5,164.8-184,186.7-172.1,181.5C468,344.5,399,184.5,399,184.5s-8,40-50,53c-36,11.1-98-14-98-78 c0-58.6,42-97,88.3-97c25.7,0,51.5,11.2,70.8,31.9C437,123.5,460,175.5,455.6,244z"
		})
	);
};

Quote.defaultProps = {
	fill: "#000000",
	scale: 1
};

Quote.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$10 = styled.svg.withConfig({
	displayName: "Robot__Svg",
	componentId: "sc-1l232oc-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Robot = function Robot(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$10,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 640 512", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M0 256v128c0 17.7 14.3 32 32 32h32V224H32c-17.7 0-32 14.3-32 32zM464 96H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H176c-44.2 0-80 35.8-80 80v272c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V176c0-44.2-35.8-80-80-80zM256 416h-64v-32h64v32zm-32-120c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm128 120h-64v-32h64v32zm96 0h-64v-32h64v32zm-32-120c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm192-72h-32v192h32c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32z"
		})
	);
};

Robot.defaultProps = {
	fill: "#000000",
	scale: 1
};

Robot.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$11 = styled.svg.withConfig({
	displayName: "Refresh__Svg",
	componentId: "sc-16c5ro3-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Refresh = function Refresh(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$11,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"
		})
	);
};

Refresh.defaultProps = {
	fill: "#000000",
	scale: 1
};

Refresh.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$12 = styled.svg.withConfig({
	displayName: "Restart__Svg",
	componentId: "sc-2pqj31-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Restart = function Restart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$12,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 21 21", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M10.5,3.6c2.1,0,4.1,0.8,5.6,2.3c3.1,3.1,3.1,8.2,0,11.3c-1.8,1.9-4.3,2.6-6.7,2.3l0.5-2c1.7,0.2,3.5-0.4,4.8-1.7 c2.3-2.3,2.3-6.1,0-8.5c-1.1-1.1-2.7-1.7-4.2-1.7v4.6l-5-5l5-5V3.6 M4.8,17.2c-2.6-2.6-3-6.6-1.2-9.7L5.1,9c-1.1,2.2-0.7,5,1.2,6.8 c0.5,0.5,1.1,0.9,1.8,1.2l-0.6,2C6.5,18.6,5.6,18,4.8,17.2z"
		})
	);
};

Restart.defaultProps = {
	fill: "#000000",
	scale: 1
};

Restart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$13 = styled.svg.withConfig({
	displayName: "Save__Svg",
	componentId: "sc-16bkg5y-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Save = function Save(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$13,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"
		})
	);
};

Save.defaultProps = {
	fill: "#000000",
	scale: 1
};

Save.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$14 = styled.svg.withConfig({
	displayName: "Search__Svg",
	componentId: "sc-oobzx4-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Search = function Search(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$14,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 19.5 19.5", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M7.5,1C11.1,1,14,3.9,14,7.5c0,1.6-0.6,3.1-1.6,4.2l0.3,0.3h0.8l5,5L17,18.5l-5-5v-0.8l-0.3-0.3c-1.1,1-2.6,1.6-4.2,1.6 C3.9,14,1,11.1,1,7.5S3.9,1,7.5,1 M7.5,3C5,3,3,5,3,7.5S5,12,7.5,12S12,10,12,7.5S10,3,7.5,3z"
		})
	);
};

Search.defaultProps = {
	fill: "#000000",
	scale: 1
};

Search.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$15 = styled.svg.withConfig({
	displayName: "SearchFile__Svg",
	componentId: "sc-c1nz3w-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SearchFile = function SearchFile(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$15,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1314.72 1533.8398", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1061.9756,1549.2037H365.004V234.4838h657.36v356.07q0,34.2375,23.9663,58.2039t58.2036,23.9662h356.07v731.2068l109.56,112.8783V590.5537q0-34.2374-17.1189-75.3225T1511.96,450.18L1244.9077,183.1274q-23.9661-23.9661-65.0513-41.0849t-75.3225-17.1187H337.614q-34.2373,0-58.2037,23.9662T255.444,207.0938v1369.5q0,34.2374,23.9663,58.2037t58.2037,23.9663h831.183Zm69.9485-1307.8724q24.8221,8.5593,35.0934,18.8306L1434.9259,528.07q10.2713,10.2711,18.8306,35.0935H1131.9241Z",
			transform: "translate(-255.444 -124.9238)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M1083.155,1082.82q0-84.7862-60.2669-145.053T877.8351,877.5q-84.7861,0-145.0531,60.2669T672.5151,1082.82q0,84.7861,60.2669,145.0531T877.8351,1288.14q84.7861,0,145.053-60.2669T1083.155,1082.82Zm366.9343,516.0242q0,23.8319-17.4156,41.2473t-41.2473,17.4156q-24.7484,0-41.2473-17.4156l-289.481-291.4555q-82.0364,56.83-182.863,56.83a317.0365,317.0365,0,0,1-125.346-25.4359q-59.8086-25.4358-103.1183-68.7455t-68.7455-103.1183a321.5653,321.5653,0,0,1,0-250.692q25.4358-59.8086,68.7455-103.1183T752.4891,785.61a321.5664,321.5664,0,0,1,250.692,0q59.8086,25.4358,103.1182,68.7455t68.7456,103.1183a317.0364,317.0364,0,0,1,25.4358,125.346q0,100.8268-56.83,182.8631l289.4809,291.9138Q1450.0892,1574.5537,1450.0893,1598.8438Z",
			transform: "translate(-255.444 -124.9238)"
		})
	);
};

SearchFile.defaultProps = {
	fill: "#000000",
	scale: 1
};

SearchFile.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$16 = styled.svg.withConfig({
	displayName: "SearchHome__Svg",
	componentId: "sc-gcz92v-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SearchHome = function SearchHome(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$16,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 24 24", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M19.31 18.9C19.75 18.21 20 17.38 20 16.5C20 14 18 12 15.5 12S11 14 11 16.5 13 21 15.5 21C16.37 21 17.19 20.75 17.88 20.32L21 23.39L22.39 22L19.31 18.9M15.5 19C14.12 19 13 17.88 13 16.5S14.12 14 15.5 14 18 15.12 18 16.5 16.88 19 15.5 19M5 20V12H2L12 3L22 12H20.18C19.33 11.11 18.23 10.47 17 10.18L12 5.69L7 10.19V18H9.18C9.35 18.72 9.64 19.39 10.03 20H5Z"
		})
	);
};

SearchHome.defaultProps = {
	fill: "#000000",
	scale: 1
};

SearchHome.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$17 = styled.svg.withConfig({
	displayName: "SelectAll__Svg",
	componentId: "sc-tndldn-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SelectAll = function SelectAll(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$17,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 225.2 191.7", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M189.4,36.8h-18.2v-18c0-9.5-7.7-17.2-17.2-17.2H35.8c-9.5,0-17.2,7.7-17.2,17.2v119.8c0,9.5,7.7,17.2,17.2,17.2h16.6v18 c0,9.5,7.7,17.2,17.2,17.2h119.8c9.5,0,17.2-7.7,17.2-17.2V54.1C206.6,44.5,198.9,36.8,189.4,36.8z M35.8,144.9 c-3.4,0-6.3-2.8-6.3-6.3V18.8c0-3.4,2.8-6.3,6.3-6.3H154c3.4,0,6.3,2.8,6.3,6.3v18H69.6c-9.5,0-17.2,7.7-17.2,17.2V145H35.8V144.9z M195.6,173.8c0,3.4-2.8,6.3-6.3,6.3H69.6c-3.4,0-6.3-2.8-6.3-6.3v-18v-11V54.1c0-3.4,2.8-6.3,6.3-6.3h90.6h11h18.2 c3.4,0,6.3,2.8,6.3,6.3V173.8z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M118.5,147c2.2,1.7,5.5,1.4,7.2-0.8l45.7-55.7c1.7-2.2,1.4-5.5-0.8-7.2l-8-6.4c-2.2-1.7-5.5-1.4-7.2,0.8l-35.8,43.7 l-19.3-16.1c-2.2-1.7-5.5-1.4-7.2,0.8l-6.4,8.1c-1.7,2.2-1.4,5.5,0.8,7.2L118.5,147z"
		})
	);
};

SelectAll.defaultProps = {
	fill: "#000000",
	scale: 1
};
SelectAll.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$18 = styled.svg.withConfig({
	displayName: "Share__Svg",
	componentId: "sc-1cakac4-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SelectAll$1 = function SelectAll(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$18,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 341.0354 473", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M257.701,370.3065V62.6883l60.1861,53.3311a8.93,8.93,0,0,0,12.49-.822l11.6682-13.3121a8.93,8.93,0,0,0-.822-12.49l-95.0677-84.24a9.8949,9.8949,0,0,0-12.3132,0l-95.0677,84.24a8.93,8.93,0,0,0-.822,12.49l11.6682,13.3121a8.93,8.93,0,0,0,12.49.822l60.186-53.3311V370.3065a8.93,8.93,0,0,0,8.851,8.851H248.85A8.93,8.93,0,0,0,257.701,370.3065Z",
			transform: "translate(-69.5151 -3)"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M410.5505,188.58a8.93,8.93,0,0,0-8.851-8.8509h-86.286a8.93,8.93,0,0,0-8.851,8.8509v17.702a8.93,8.93,0,0,0,8.851,8.851h59.7331V440.5961H104.919V215.1327h57.4176a8.93,8.93,0,0,0,8.851-8.851V188.58a8.9294,8.9294,0,0,0-8.851-8.8509H78.366a8.9294,8.9294,0,0,0-8.8509,8.8509V452.6344h.1058V467.149A8.93,8.93,0,0,0,78.4719,476H401.5936a8.93,8.93,0,0,0,8.851-8.851V452.6344h.1059Z",
			transform: "translate(-69.5151 -3)"
		})
	);
};

SelectAll$1.defaultProps = {
	fill: "#000000",
	scale: 1
};
SelectAll$1.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$19 = styled.svg.withConfig({
	displayName: "SmallFlame__Svg",
	componentId: "sc-1vi51mj-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SmallFlame = function SmallFlame(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$19,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 223.8135 391.9949", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M237.4016,36.7483c38,98-11.3972,133.3136-77.5,185.5C86.8736,287.32,108.0493,406.0549,260.0605,428.7432c-31.8639-55.4016,50.57-87.1651,71.7457-146.9109C384.4211,133.3831,237.4016,36.7483,237.4016,36.7483ZM221.2545,388.5439c-106.1141-103.814,40.29-118.2256,61.1407-210.75C283.6984,313.9743,193.33,303.6258,221.2545,388.5439Z",
			transform: "translate(-119.3654 -36.7483)"
		})
	);
};

SmallFlame.defaultProps = {
	fill: "#000000",
	scale: 1
};

SmallFlame.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1a = styled.svg.withConfig({
	displayName: "SpeechBubble__Svg",
	componentId: "sc-i8sba0-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SpeechBubble = function SpeechBubble(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1a,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22-17 2-30.5-9t-17.5-29v-1q-3-4-.5-12t2-10 4.5-9.5l6-9 7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5q244 0 450 85.5t326 233 120 321.5z"
		})
	);
};

SpeechBubble.defaultProps = {
	fill: "#000000",
	scale: 1
};

SpeechBubble.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1b = styled.svg.withConfig({
	displayName: "SquareEmpty__Svg",
	componentId: "sc-14g0rxh-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SquareEmpty = function SquareEmpty(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1b,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 456 456", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M426.0769,468.3H51.9231A40.969,40.969,0,0,1,11,427.3768V53.223A40.969,40.969,0,0,1,51.9231,12.3H426.0769A40.969,40.969,0,0,1,467,53.223V427.3768A40.969,40.969,0,0,1,426.0769,468.3ZM57.7692,421.5307H420.2308V59.0691H57.7692Z",
			transform: "translate(-11 -12.2999)"
		})
	);
};

SquareEmpty.defaultProps = {
	fill: "#000000",
	scale: 1
};

SquareEmpty.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1c = styled.svg.withConfig({
	displayName: "SquareLight__Svg",
	componentId: "sc-1lp1e74-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SquareLight = function SquareLight(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1c,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 456 456", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M426.0769,12.3H51.9231A40.969,40.969,0,0,0,11,53.223V427.3768A40.969,40.969,0,0,0,51.9231,468.3H426.0769A40.969,40.969,0,0,0,467,427.3768V53.223A40.969,40.969,0,0,0,426.0769,12.3ZM233.95,59.0691l-176.18,176.18V59.0691ZM57.7692,301.3908,300.091,59.0691h120.14V170.9418L169.6415,421.5307H57.7692Zm178.0141,120.14L420.2308,237.0831V421.5307Z",
			transform: "translate(-11 -12.2999)"
		})
	);
};

SquareLight.defaultProps = {
	fill: "#000000",
	scale: 1
};

SquareLight.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1d = styled.svg.withConfig({
	displayName: "SquareMedium__Svg",
	componentId: "sc-z80lzy-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SquareMedium = function SquareMedium(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1d,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 456 456", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M11,53.223V427.3768A40.969,40.969,0,0,0,51.9231,468.3H426.0769A40.969,40.969,0,0,0,467,427.3768V53.223A40.969,40.969,0,0,0,426.0769,12.3H51.9231A40.969,40.969,0,0,0,11,53.223ZM420.2308,158.4862,320.8137,59.0691h99.4171Zm0,151.575L169.2387,59.0691h85.4332L420.2308,224.628Zm-362.4616,6.83,104.64,104.64H57.7692Zm0-151.575L313.9841,421.5307H228.5509L57.7692,250.749Zm0-106.2467h45.3277L420.2308,376.2026v45.3281H380.1259L57.7692,99.174Z",
			transform: "translate(-11 -12.2999)"
		})
	);
};

SquareMedium.defaultProps = {
	fill: "#000000",
	scale: 1
};

SquareMedium.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1e = styled.svg.withConfig({
	displayName: "SquareDark__Svg",
	componentId: "sc-11o69xb-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SquareDark = function SquareDark(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1e,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 456 456", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M426.0769,12.3H51.9231A40.969,40.969,0,0,0,11,53.223V427.3768A40.969,40.969,0,0,0,51.9231,468.3H426.0769A40.969,40.969,0,0,0,467,427.3768V53.223A40.969,40.969,0,0,0,426.0769,12.3ZM57.7692,235.2491l176.18-176.18H300.091L57.7692,301.3908Zm362.4616,1.834L235.7833,421.5307H169.6415L420.2308,170.9418Z",
			transform: "translate(-11 -12.2999)"
		})
	);
};

SquareDark.defaultProps = {
	fill: "#000000",
	scale: 1
};

SquareDark.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1f = styled.svg.withConfig({
	displayName: "SquareFull__Svg",
	componentId: "sc-xbk8ck-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var SquareFull = function SquareFull(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1f,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 456 456", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M426.0769,468.3H51.9231A40.969,40.969,0,0,1,11,427.3768V53.223A40.969,40.969,0,0,1,51.9231,12.3H426.0769A40.969,40.969,0,0,1,467,53.223V427.3768A40.969,40.969,0,0,1,426.0769,468.3Z",
			transform: "translate(-11 -12.2999)"
		})
	);
};

SquareFull.defaultProps = {
	fill: "#000000",
	scale: 1
};

SquareFull.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1g = styled.svg.withConfig({
	displayName: "Star__Svg",
	componentId: "sc-diojay-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Star = function Star(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1g,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"
		})
	);
};

Star.defaultProps = {
	fill: "#000000",
	scale: 1
};

Star.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1h = styled.svg.withConfig({
	displayName: "Support__Svg",
	componentId: "sc-16rxuxn-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Support = function Support(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1h,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zm0 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zm-678 1129l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zm678 407q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zm0-384q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zm484-217l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"
		})
	);
};

Support.defaultProps = {
	fill: "#000000",
	scale: 1
};

Support.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1i = styled.svg.withConfig({
	displayName: "Synopsis__Svg",
	componentId: "sc-sxp1r2-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Synopsis = function Synopsis(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1i,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 480 480", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M384.1,37.7H109.9C95.7,37.7,84,49.3,84,63.6v357.1c0,14.3,11.7,25.9,25.9,25.9h274.1c14.3,0,25.9-11.7,25.9-25.9V63.6 C410,49.3,398.3,37.7,384.1,37.7z M380,404c0,6.6-5.4,12-12,12H126c-6.6,0-12-5.4-12-12V80.3c0-6.6,5.4-12,12-12h242 c6.6,0,12,5.4,12,12V404z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M336,207.9H158c-6.6,0-12-5.4-12-12V184c0-6.6,5.4-12,12-12h178c6.6,0,12,5.4,12,12v11.9C348,202.5,342.6,207.9,336,207.9z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M336,372H158c-6.6,0-12-5.4-12-12v-11.9c0-6.6,5.4-12,12-12h178c6.6,0,12,5.4,12,12V360C348,366.6,342.6,372,336,372z"
		}),
		React.createElement("path", {
			fill: fill,
			d: "M336,289.9H158c-6.6,0-12-5.4-12-12v-11.9c0-6.6,5.4-12,12-12h178c6.6,0,12,5.4,12,12v11.9 C348,284.5,342.6,289.9,336,289.9z"
		})
	);
};

Synopsis.defaultProps = {
	fill: "#000000",
	scale: 1
};

Synopsis.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1j = styled.svg.withConfig({
	displayName: "TinyFlame__Svg",
	componentId: "sc-2fgr2b-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var TinyFlame = function TinyFlame(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1j,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 260 363", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M247.9491,57.4481s-130,144.4253-130,235,58.203,128,130,128,130-37.4253,130-128S247.9491,57.4481,247.9491,57.4481Zm0,336c-37.0031,0-67-17.036-67-58.2655s67-106.9717,67-106.9717,67,65.7422,67,106.9717S284.9521,393.4481,247.9491,393.4481Z",
			transform: "translate(-117.9491 -57.4481)"
		})
	);
};

TinyFlame.defaultProps = {
	fill: "#000000",
	scale: 1
};

TinyFlame.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1k = styled.svg.withConfig({
	displayName: "Trash__Svg",
	componentId: "sc-t6hx64-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Trash = function Trash(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1k,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"
		})
	);
};

Trash.defaultProps = {
	fill: "#000000",
	scale: 1
};

Trash.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1l = styled.svg.withConfig({
	displayName: "Umbrella__Svg",
	componentId: "sc-16a447f-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Umbrella = function Umbrella(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1l,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M960 828v580q0 104-76 180t-180 76-180-76-76-180q0-26 19-45t45-19 45 19 19 45q0 50 39 89t89 39 89-39 39-89v-580q33-11 64-11t64 11zm768 27q0 13-9.5 22.5t-22.5 9.5q-11 0-23-10-49-46-93-69t-102-23q-68 0-128 37t-103 97q-7 10-17.5 28t-14.5 24q-11 17-28 17-18 0-29-17-4-6-14.5-24t-17.5-28q-43-60-102.5-97t-127.5-37-127.5 37-102.5 97q-7 10-17.5 28t-14.5 24q-11 17-29 17-17 0-28-17-4-6-14.5-24t-17.5-28q-43-60-103-97t-128-37q-58 0-102 23t-93 69q-12 10-23 10-13 0-22.5-9.5t-9.5-22.5q0-5 1-7 45-183 172.5-319.5t298-204.5 360.5-68q140 0 274.5 40t246.5 113.5 194.5 187 115.5 251.5q1 2 1 7zm-768-727v98q-42-2-64-2t-64 2v-98q0-26 19-45t45-19 45 19 19 45z"
		})
	);
};

Umbrella.defaultProps = {
	fill: "#000000",
	scale: 1
};

Umbrella.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1m = styled.svg.withConfig({
	displayName: "User__Svg",
	componentId: "sc-vuof52-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var User = function User(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1m,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1792 1792", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1600 1405q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q9 0 42 21.5t74.5 48 108 48 133.5 21.5 133.5-21.5 108-48 74.5-48 42-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-320-893q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
		})
	);
};

User.defaultProps = {
	fill: "#000000",
	scale: 1
};

User.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1n = styled.svg.withConfig({
	displayName: "Users__Svg",
	componentId: "sc-agb4su-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Users = function Users(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1n,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "-50 -100 1900 2000", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M529 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zm1071 637q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-1024-1277q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm704 384q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zm576 225q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zm-128-609q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z"
		})
	);
};

Users.defaultProps = {
	fill: "#000000",
	scale: 1
};

Users.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1o = styled.svg.withConfig({
	displayName: "VolumeChart__Svg",
	componentId: "sc-1bxbjci-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var VolumeChart = function VolumeChart(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1o,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "0 0 1761.2 1320.9", scale: scale },
		React.createElement("polygon", {
			fill: fill,
			points: "1761.2 1210.8 1761.2 1320.9 0 1320.9 0 0 110.1 0 110.1 1210.8 1761.2 1210.8"
		}),
		React.createElement("polygon", {
			fill: fill,
			points: "1574.222 39.123 234.546 1021.224 226.599 1027.049 301.97 1133.11 1643.077 149.961 1651.143 144.049 1574.222 39.123"
		})
	);
};

VolumeChart.defaultProps = {
	fill: "#000000",
	scale: 1
};

VolumeChart.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1p = styled.svg.withConfig({
	displayName: "Warning__Svg",
	componentId: "sc-l7dv8-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Warning = function Warning(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1p,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "-30 -80 1850 1850", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"
		})
	);
};

Warning.defaultProps = {
	fill: "#000000",
	scale: 1
};

Warning.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1q = styled.svg.withConfig({
	displayName: "X__Svg",
	componentId: "sc-1prb5aw-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var X = function X(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1q,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "-5 -5 380 380", scale: scale },
		React.createElement("path", {
			fill: fill,
			d: "M284,239.5,423,100.57a6.55,6.55,0,0,0,0-9.23L387.66,56a6.55,6.55,0,0,0-9.23,0L239.5,195,100.57,56a6.55,6.55,0,0,0-9.23,0L56,91.34a6.55,6.55,0,0,0,0,9.23L195,239.5,56,378.43a6.55,6.55,0,0,0,0,9.23L91.34,423a6.55,6.55,0,0,0,9.23,0L239.5,284,378.43,423a6.55,6.55,0,0,0,9.23,0L423,387.66a6.55,6.55,0,0,0,0-9.23Z",
			transform: "translate(-54.12 -54.12)"
		})
	);
};

X.defaultProps = {
	fill: "#000000",
	scale: 1
};

X.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

var Svg$1r = styled.svg.withConfig({
	displayName: "Yuan__Svg",
	componentId: "sc-1vc423n-0"
})(["height:100%;width:100%;transform:", ";"], function (props) {
	return "scale(" + props.scale + ")";
});

var Yuan = function Yuan(props) {
	var fill = props.fill,
	    scale = props.scale;

	return React.createElement(
		Svg$1r,
		{ version: "1.1", x: "0px", y: "0px", viewBox: "-5 -5 340 300", scale: scale },
		React.createElement("rect", { fill: fill, x: "45.9288", width: "237", height: "39", rx: "3" }),
		React.createElement("path", {
			fill: fill,
			d: "M402.5579,339.2728l-21.4511-12.7192A3.0087,3.0087,0,0,0,377,327.62S363.6584,364,355.6218,364H296.9642c-3.3791,0-4.3791-2-4.3791-5V235.9872h96.0762a3.0089,3.0089,0,0,0,3-3v-33a3.0088,3.0088,0,0,0-3-3H95.7415a3.0088,3.0088,0,0,0-3,3v33a3.0089,3.0089,0,0,0,3,3h93.8068c1.0035,19.3392-1.0626,62.5121-34.9632,91.0128-27.7029,23.29-68.7623,41.8495-74.95,44.56a2.9026,2.9026,0,0,0-1.2436,4.51l15.1224,28.1551a3.0087,3.0087,0,0,0,4.207.5485s53.7718-26.8908,84.4587-50.9c42.2246-33.0368,43.8289-101.0525,43.55-117.8856h27.8553V367c0,23,11,36,30,36h78c13,0,20-7,24-13s19-36,19-36C407.5851,347,407.5851,343,402.5579,339.2728Z",
			transform: "translate(-77.7726 -114)"
		})
	);
};

Yuan.defaultProps = {
	fill: "#000000",
	scale: 1
};

Yuan.propTypes = {
	fill: PropTypes.string,
	scale: PropTypes.number
};

// This function is one of the worst hacks of all time. Another solution is needed

// NOTE: this should match addIconsToContentType in the Narrative Tracker

var pickIcon = function pickIcon(params) {
	var type = params.type,
	    color = params.color;


	var lowType = type ? type.toLowerCase() : "";

	switch (lowType) {
		case "print":
			return React.createElement(Newspaper, { fill: color });
		case "broadcast":
			return React.createElement(Microphone, { fill: color });
		case "event":
			return React.createElement(MapPin, { fill: color });
		case "analysis":
			return React.createElement(Synopsis, { fill: color });
		case "quote":
			return React.createElement(Quote, { fill: color });
		case "chart":
			return React.createElement(LineChart, { fill: color });
		case "social":
			return React.createElement(User, { fill: color });
		case "featured":
			return React.createElement(Star, { fill: color });

		case "739e6d2a73723ec7b1919fa5a51f9b07":
			return React.createElement(Synopsis, { fill: color });
		case "a188b63325f862df8fb2e0a0452f5eda":
			return React.createElement(Newspaper, { fill: color });
		case "a4ecfc70574394990cf17bd83df499f7":
			return React.createElement(MapPin, { fill: color, scale: 1.2 });
		case "1d36783e12317ed400ebeddeb072a27b":
			return React.createElement(LineChart, { fill: color });
		case "c84ea71b6da11034c6dfa3710c57b3ee":
			return React.createElement(User, { fill: color });
		case "74ecdfd16dd669e83d390d55ab5e0a0c":
			return React.createElement(Users, { fill: color });
		case "be53a0541a6d36f6ecb879fa2c584b08":
			return React.createElement(Image, { fill: color });
		case "239658e016e3d5d06ae719d280a79fec":
			return React.createElement(Data, { fill: color });
		case "89c1265be62d3ba835a3d963db5956b0":
			return React.createElement(Umbrella, { fill: color, scale: 1.1 });
		case "f8cd85705829d9bf9cabcb36421b0094":
			return React.createElement(NewspaperStack, { fill: color, scale: 1.1 });
		case "0945359809dad1fbf3dea1c95a0da951":
			return React.createElement(File, { fill: color });
		case "6311ae17c1ee52b36e68aaf4ad066387":
			return React.createElement(DotPyramid, { fill: color });
		case "1782e50fa12a993f7f375801425b04ac":
			return React.createElement(LineChartDashed, { fill: color });

		default:
			return "";
	}
};

export { Aggregate, AreaChart, Arrow, BarChart, Broadcast, Brush, Building, Caret, Checkmark, ChevronDown, ChevronRight, Clipboard, CogOutline, Collapse, Colorblind, ClearX, ClosePin, Copy, Crosshairs, Data, Dollar, DotPyramid, DotsHorizontal, DotsHorizontal$1 as DotsVertical, Download, DownloadImage, Envelope, Expand, Filter, FilterSettingsOutline, FilterOutline, File, Flame, Gear, Image, Info, Info$1 as InfoDot, LightUI, Line, Link, LineChart, LineChartDashed, List, ListBoxOutline, Lock, LogChart, MapPin, MeatballSub, Microphone, MicrophoneO, Microscope, Newspaper, NewspaperPin, NewspaperStack, Note, OpenInNew, Palette, Pause, Pencil, Play, PlayCircle, Plus, Quote, Refresh, Restart, Robot, Save, Search, SearchFile, SearchHome, SelectAll, SelectAll$1 as Share, SmallFlame, SpeechBubble, SquareEmpty, SquareLight, SquareMedium, SquareDark, SquareFull, Star, Support, Synopsis, TinyFlame, Trash, Umbrella, User, Users, VolumeChart, Warning, X, Yuan, pickIcon };
//# sourceMappingURL=index.es.js.map
